import React, { useCallback, useEffect, useState } from 'react'
import { LibraryHeader } from '../../../components/Library/LibraryHeader'
import { LibraryOscCard } from '../../../components/Library/LibraryOscCard'
import useApi from '../../../hooks/useApi'
import { OscLoggedLayout } from '../../../layout/OscLoggedLayout'
import { Ebook } from '../../../types/Ebook'

export const Ebooks = () => {
    
    const api = useApi() 
    const [ebooks,setEbooks] = useState<Ebook[]>([])


    const loadEbooks = useCallback(async ()=>{
        await api.get("/client/library/ebooks").then(res => {
                setEbooks(res.data)
        }).catch(console.log)
    },[api,setEbooks])

    useEffect(()=>{
        loadEbooks()
    },[loadEbooks])

    return(
        <OscLoggedLayout>
             <LibraryHeader osc page='Ebook'/>
             <div className='grid grid-cols-3 gap-x-16 gap-y-2'>
             {ebooks.map(item => (
                 <LibraryOscCard type="ebooks" download item={item} />
             ))}
             </div>
        </OscLoggedLayout>
    )
}
